import { Injectable, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserPermissionCheckService } from '@pf/shared-services';

@Injectable({
    providedIn: 'root',
})
export class FirebendAdminGuard {
    private permissionCheckService = inject(UserPermissionCheckService);

    canActivate():
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        return this.permissionCheckService.isFirebendAdmin$();
    }

    canLoad():
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        return this.permissionCheckService.isFirebendAdmin$();
    }
}
